import { debounce, get, map, sortBy } from 'lodash';
import cx from 'classnames';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './Deliveries.module.css';
import BookingRow from './BookingRow';

class BookingsList extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    this.headers = [
      'Time',
      'Reference',
      'Vendor',
      'Grade',
      'PO #',
      'New or R/S',
      'Boxes',
      'Boxes Received',
      'Boxes Remaining',
      'Units',
      'Delivered At',
      'Notes',
    ];
    if (
      this.props.rowPerms.canDeleteDelivery ||
      this.props.rowPerms.canUpdateDelivery
    ) {
      this.headers.push('');
    }
  }

  render() {
    const {
      bookings,
      editBooking,
      removeBooking,
      saveDelivery,
      checkInDelivery,
      toggleDetails,
      updateRole,
      currentUser,
      rowPerms,
      pagePerms,
    } = this.props;

    return (
      <div className={styles.bookingsContainer}>
        <div
          className={styles.bookingsHeaders}
          data-testid="deliveries-bookings-headers"
        >
          {this.headers.map((header) => (
            <h6
              className={cx(styles.bookingsHeader, {
                [styles.bookingsHeaderCheckIn]: header === 'Delivered At',
                [styles.bookingsHeaderNotes]: header === 'Notes',
              })}
              key={header}
            >
              {header}
            </h6>
          ))}
        </div>
        <div
          className={styles.bookingsBody}
          data-testid="deliveries-bookings-body"
        >
          {map(
            sortBy(bookings, [
              'starts_at',
              (b) => get(b, 'vendor.company_name'),
            ]),
            (booking) => (
              <BookingRow
                saveDelivery={debounce(saveDelivery, 500)}
                checkInDelivery={debounce(checkInDelivery, 500)}
                editBooking={editBooking}
                removeBooking={removeBooking}
                key={booking.id}
                booking={booking}
                currentUser={currentUser}
                toggleDetails={toggleDetails}
                updateRole={updateRole}
                rowPerms={rowPerms}
                pagePerms={pagePerms}
              />
            ),
          )}
        </div>
      </div>
    );
  }
}

BookingsList.propTypes = {
  bookings: PropTypes.shape({}).isRequired,
  currentUser: PropTypes.shape({}).isRequired,
  editBooking: PropTypes.func.isRequired,
  removeBooking: PropTypes.func.isRequired,
  saveDelivery: PropTypes.func.isRequired,
  checkInDelivery: PropTypes.func.isRequired,
  toggleDetails: PropTypes.func.isRequired,
  updateRole: PropTypes.bool,
  rowPerms: PropTypes.shape({
    canUpdateDelivery: PropTypes.bool,
    canDeleteDelivery: PropTypes.bool,
  }).isRequired,
  pagePerms: PropTypes.shape({
    canUpdatePackingList: PropTypes.bool,
    canReadPackingList: PropTypes.bool,
  }).isRequired,
};

BookingsList.defaultProps = {
  updateRole: false,
};

export default BookingsList;
